module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/lottie/brand-spinner-6096c7a973bff82bd8a776541c75f49d.lottie";